<template>
  <div style="display: flex; justify-content: center; padding: 40px;">
    <div style="display: flex; flex-direction: column; align-items: center; max-width: 330px;
        padding: 15px; width: 100%!important;">
      <img style="margin-bottom: 1rem!important;" :src="require('../assets/logo_isolutions.png')" alt="" width="700"
        height="150">
      <h1 style="margin-bottom: 20px; font-weight: 400!important; font-size: calc(1.3rem + .6vw);"><strong>
          Iniciar Sesión
        </strong></h1>
      <vs-input
        style="text-align: start!important; margin-bottom: -1px; border-bottom-right-radius: 0; border-bottom-left-radius: 0;"
        success-text="Correo Valido" danger-text="The email does not meet the requirements" type="email"
        placeholder="Usuario" v-model="form.email" />
      <vs-input
        style="text-align: start!important; margin-top: 0px!important; margin-bottom: 20px; border-top-left-radius: 0; border-top-right-radius: 0;"
        success-text="Password Valida" type="password" placeholder="Contraseña" v-model="form.password" />
      <vs-button style="background-color: #164077!important;" color="primary" type="filled"
        @click="login();">Ingresar</vs-button>
      <p style="margin-top: 40px; color: #6c757d!important;">By iSolutions</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { vsButton, vsInput } from 'vuesax'
import 'vuesax/dist/vuesax.css'
import jwtToken from "../helpers/jwt-token";
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');

Vue.use(vsButton)
Vue.use(vsInput)

export default {
  components: {
  },
  data: () => ({
    form: {
      email: '',
      password: '',
    },

    scr: '',
  }),
  methods: {
    login() {
      this.axios.post(serverUrl + '/api/login', this.form)
        .then(res => {
          if (res.data.success == true) {
            jwtToken.setToken(res.data.token);
            let tipo = {
              "name": res.data.info.licencia.name,
              "id_company": res.data.info.licencia.id_company,
              "payment_data": res.data.info.licencia.payment_data,
              "status_commercial": res.data.info.licencia.status_commercial,
              "counter": res.data.info.licencia.counter,
            }
            let tipo1 = {
              "email": res.data.info.usuario.email,
              "rol": res.data.info.usuario.rol,
              "name": res.data.info.usuario.name,
              "report": res.data.info.usuario.report
            }
            window.localStorage.setItem('jwt_user', JSON.stringify(tipo1));
            window.localStorage.setItem('jwt_licencia', JSON.stringify(tipo));
            if (res.data.info.licencia.status_commercial == 'MORA') {
              this.$vs.notify({
                title: 'Error',
                text: 'Tu ultimo pago no pudo ser procesado',
                color: 'danger'
              })
            } else {
              location.href = location.origin + '/#/admin/overview';
            }
          } else {
            console.log(res.data);
            window.alert("Credenciales invalidas");
          }
        })
        .catch(err => {
          console.log(err.data);
          window.alert("ERROR, intente nuevamente");
        });
    }
  },
  mounted() {

  }
}
</script>
<style>
.vuesax-app-is-ltr {
  background-color: #f5f5f5;
}

.vs-button {
  border-radius: 6px !important;
  width: 100%;
  margin: 0%;
  height: calc(3.5rem + 2px);
  font-size: 1.2rem;
}

.vs-input {
  width: 100% !important;

}

input {
  height: calc(3.5rem + 2px);
  border: none;
  font-size: 1rem;
}
</style>
